import React from 'react';

interface StructuredDataProps {
  data: Record<string, any>;
}

export const StructuredData: React.FC<StructuredDataProps> = ({ data }) => {
  // Helper to escape closing script tags inside the JSON string to prevent premature script termination
  const jsonString = JSON.stringify({
    '@context': 'https://schema.org',
    ...data,
  }).replace(/<\/script>/g, '<\\/script>');

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: jsonString,
      }}
    />
  );
};